<!-- <div id="" class="container home-testimonials my-md-5 my-3">
  <div class="row">
    <div class="col-md-5 col-sm-12 text-center text-md-start">
      <span class="h1 text-uppercase fw-normal mb-2">
        Ils ont RÉALISÉ leur projet immo AVEC nous, <span class="text-bleu-tdm">alors pourquoi pas vous&nbsp;?</span>
      </span>
      <div class="notation-opinion-system my-3">
        <a href="https://www.opinionsystem.fr/fr-fr/search/group/2040" target="_blank" rel="noopener noreferrer" title="Consulter nos avis Opinion System">
          <img src="assets/svg/notation-opinion-system.svg" alt="Avis Opinion System" style="height: 28px; width: auto;" />
        </a>
      </div>
      <div>
        <button (click)="onNavigateAvis()" class="btn btn-primary">Voir tous les avis</button>
      </div>
    </div>
    <div class="col-md-7 col-sm-12 home-testimonials-body">
      <div class="mb-md-0 mb-sm-3 d-none d-md-block">
        <img src="../../../assets/resources/web/images/design/quotes.png">
      </div>
      <div class="testimonials-list my-4 my-md-0">
        <div class="testimonials-list-item align-self-lg-start mx-lg-5 my-lg-2" *ngFor="let opinion of opinionSystemList; let i = index">
          <div class="testimonials-list-item-body">
            {{opinion.comment}}
          </div>
          <div class="testimonials-list-item-footer my-3">
            <div class="infos">
              <div class="name text-bleu-tdm fw-semibold">
                {{opinion.name}}
              </div>
              <div class="date text-black-50">
                Le {{opinion.answer | date:'dd/MM/yyyy'}}
              </div>
            </div>
            <div class="notation rating-star">
              <ngb-rating [max]="5" [readonly]="true" title="indice de satisfaction: {{opinion.rating}}%"
                [(rate)]="opinion.rating"></ngb-rating>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div> -->

<div id="" class="container home-testimonials my-md-5 my-3">
  <div class="row">
    <div class="col-md-5 col-sm-12 text-center text-md-start">
      <span class="h1 text-uppercase fw-normal mb-2">
        Ils ont RÉALISÉ leur projet immo AVEC nous, <span class="text-bleu-tdm">alors pourquoi pas vous&nbsp;?</span>
      </span>
      <div class="notation-opinion-system my-3">
        <a href="https://www.opinionsystem.fr/fr-fr/search/group/2040" target="_blank" rel="noopener noreferrer" title="Consulter nos avis Opinion System" class="d-inline-block">
          <img src="assets/svg/notation-opinion-system.svg" alt="Avis Opinion System" style="height: 28px; width: auto;" />
        </a>
      </div>
      <div>
        <button (click)="onNavigateAvis()" class="btn btn-primary">Voir tous les avis</button>
      </div>
    </div>
    <div class="col-md-7 col-sm-12 home-testimonials-body">
      <div class="mb-md-0 mb-sm-3 d-none d-md-block">
        <img width="120" height="88" src="../../../assets/resources/web/images/design/quotes.png">
      </div>
      <div class="testimonials-list my-4 my-md-0">
        <div class="testimonials-list-item align-self-lg-start mx-lg-5 my-lg-2">
          <div class="testimonials-list-item-body">
            {{opinionSystemList[0]?.comment}}
          </div>
          <div class="testimonials-list-item-footer my-3">
            <div class="infos">
              <div class="name text-bleu-tdm fw-semibold">
                {{opinionSystemList[0]?.name}}
              </div>
              <div class="date text-black-50">
                Le {{opinionSystemList[0]?.answer|date:'dd/MM/yyyy'}}
              </div>
            </div>
            <div class="notation rating-star">
<!--              <ngb-rating [max]="5" [readonly]="true" [rate]="opinionSystemList[0]?.rating"></ngb-rating>-->
<!--              <ngb-rating [max]="5" [readonly]="true"  [(rate)]="currentRate"></ngb-rating>-->
              <ngb-rating [max]="5" [readonly]="true" title="indice de satisfaction: {{opinionSystemList[0]?.rating}}%"
                [(rate)]="rating0"></ngb-rating>
            </div>
          </div>
        </div>
        <div class="testimonials-list-item align-self-lg-end">
          <div class="testimonials-list-item-body">
            {{opinionSystemList[1]?.comment}}
          </div>
          <div class="testimonials-list-item-footer my-3">
            <div class="infos">
              <div class="name text-bleu-tdm fw-semibold">
                {{opinionSystemList[1]?.name}}
              </div>
              <div class="date text-black-50">
                Le {{opinionSystemList[1]?.answer|date:'dd/MM/yyyy'}}
              </div>
            </div>
            <div class="notation rating-star">
<!--              <ngb-rating [max]="5" [readonly]="true" [(rate)]="currentRate"></ngb-rating>-->
              <ngb-rating [max]="5" [readonly]="true" title="indice de satisfaction: {{opinionSystemList[1]?.rating}}%"
                [(rate)]="rating1"></ngb-rating>
            </div>
          </div>
        </div>
        <div class="testimonials-list-item align-self-lg-start w-auto">
          <div class="testimonials-list-item-body">
            {{opinionSystemList[2]?.comment}}
          </div>
          <div class="testimonials-list-item-footer my-3">
            <div class="infos">
              <div class="name text-bleu-tdm fw-semibold">
                {{opinionSystemList[2]?.name}}
              </div>
              <div class="date text-black-50">
                Le {{opinionSystemList[2]?.answer|date:'dd/MM/yyyy'}}
              </div>
            </div>
            <div class="notation rating-star">
<!--              <ngb-rating [max]="5" [readonly]="true" [(rate)]="currentRate"></ngb-rating>-->
              <ngb-rating [max]="5" [readonly]="true" title="indice de satisfaction: {{opinionSystemList[2]?.rating}}%"
                [(rate)]="rating2"></ngb-rating>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

